import React from "react";

const Input = ({ name, label, value, onChange, error, type,onBlur,required }) => {
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}  
      {required && (<span class="required ml-1 text-danger">*</span>)}
      </label>
      <input
        value={value}
        onBlur={onBlur}
        onChange={onChange}
        name={name}
        type={type}
        id={name}
        className="form-control"
      />
      {error && <div className="text-danger p-1 m-12" role="alert">{error}</div>}
    </div>
  );
};

export default Input;
